import { SubsDataSource } from "./SubsDataSource";
import { PlanResponse, SubsResponse } from "@/data/dtos/responses";
import { ApiService } from "@/domain/clients";
import { Endpoints } from "@/infra/api";
import { SubsRequest } from "@/data/dtos/requests";
import { NotFoundError } from "@/domain/errors";

export class SubsRemoteDataSource implements SubsDataSource {
  constructor(private readonly api: ApiService) {}

  async listPlans() {
    const { data } = await this.api.get<PlanResponse[]>(Endpoints.plans);

    if (!data) return [];

    return data;
  }

  subscribe = async (params: SubsRequest) => {
    const { data } = await this.api.post<SubsResponse, SubsRequest>(
      Endpoints.subscriptions,
      params,
    );
    if (!data)
      throw new Error(
        "Ocorreu um problema ao carregar as informações do plano.",
      );
    return data;
  };

  reactivateSubs = (id: number) => {
    return this.api.post(`${Endpoints.subscriptions}/${id}/reactivate`, {});
  };

  manualPaymentSubs = (id: number) => {
    return this.api.post(`${Endpoints.subscriptions}/${id}/manual-pay`, {});
  };

  cancelSubs = (id: number) => {
    return this.api.delete(`${Endpoints.subscriptions}/${id}`);
  };

  showSubs = async (id: number) => {
    if (!id) {
      throw new Error("Erro ao buscar assinatura");
    }

    const { data } = await this.api.get<SubsResponse>(
      `${Endpoints.subscriptions}/${id}`,
    );

    if (!data) {
      throw new Error("Erro ao buscar assinatura");
    }

    return data;
  };

  updateSubs = (id: number, params: { card_id: string }) => {
    return this.api.put(`${Endpoints.subscriptions}/${id}`, params);
  };

  async getPlanDetails() {
    const { data } = await this.api.get<PlanResponse>(Endpoints.plan_details);

    if (!data) {
      throw new NotFoundError("Plano");
    }

    return data;
  }
}
